import Vuex, { Store } from 'vuex';

import Vue from 'vue';
import admin from './admin';
import auth from './auth';
import broadcast from './broadcast';
import question from './question';
import saib from './saib';
import uncle from './uncle';
import wholesale from './wholesale';
import master from './master';

Vue.use(Vuex);

const store = new Store({
  strict: true,
  modules: {
    auth,
    saib,
    wholesale,
    broadcast,
    question,
    admin,
    uncle,
    master,
  },
});

export default store;
